import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    document.addEventListener('DOMContentLoaded', () => {
      if (window.location.hash == `#${this.element.id}`) {
        this.element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    })
  }
}
